module.exports = __webpack_public_path__ + "media/images/front/banner_minna-d77c5aa066cfc92cfe95fc2053dae230.png";